import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";

const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-base font-bold text-slate-100">{title}</h2>
    <div className="text-sm text-slate-300 leading-relaxed space-y-1">{children}</div>
  </section>
);

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 flex flex-col">
      <header className="bg-[#0B0F17]/95 border-b border-slate-800 sticky top-0 z-10 px-4 py-3 flex items-center gap-3">
        <Link to="/" data-testid="legal-back" className="h-10 w-10 flex items-center justify-center rounded-lg bg-slate-800 hover:bg-slate-700"><ArrowLeft size={18} /></Link>
        <h1 className="font-black tracking-tight text-lg">Mentions légales</h1>
      </header>

      <div data-testid="mentions-legales-page" className="flex-1 max-w-2xl mx-auto px-4 py-6 space-y-6">
        <p className="text-xs text-slate-500">Conformément à l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN).</p>

        <Section title="1. Éditeur du site">
          <p><span className="text-slate-100 font-semibold">Alliance Web AH L.L.C.</span>, société à responsabilité limitée de droit américain (Limited Liability Company), État du Wyoming, USA.</p>
          <p>N° de dossier (Entity ID) : 2026-002058605</p>
          <p>Activité : création de contenu Internet et production de médias numériques.</p>
          <p>Gestion : Member Managed. Membre unique : Antoine CUTTITTA.</p>
          <p>Siège / adresse officielle : 30 N Gould St, Ste N, Sheridan, WY 82801, USA.</p>
          <p>Agent enregistré : Northwest Registered Agent Service Inc, 1603 Capitol Ave Ste 413, Cheyenne, WY 82001, USA.</p>
          <p>Contact : <a href="mailto:antoine@ah2020.fr" className="text-sky-400 hover:underline">antoine@ah2020.fr</a> · Fax US : +1 (855) 892-6513 · Site : <a href="https://ah2020.fr" target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:underline">ah2020.fr</a></p>
          <p>Constitution : Articles of Organization déposés le 17/08/2026 et certifiés par le Secretary of State du Wyoming ; Operating Agreement du 07/08/2026 ; Initial Resolutions du 18/08/2026.</p>
          <p>EIN : EIN en cours d'obtention.</p>
        </Section>

        <Section title="2. Directeur de la publication">
          <p>Antoine CUTTITTA.</p>
        </Section>

        <Section title="3. Hébergeur">
          <p>IONOS Inc., 701 Lee Road, Suite 300, Chesterbrook, PA 19087, USA. Site : <a href="https://www.ionos.com" target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:underline">www.ionos.com</a>.</p>
        </Section>

        <Section title="4. Nature du site">
          <p>Le présent site est accessible à l'adresse <a href="https://alliancemanif.fr" target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:underline">alliancemanif.fr</a>.</p>
          <p>Alliance Manif est une plateforme d'information sur les manifestations et blocages, à vocation strictement informative et neutre. Les contenus proposés par les visiteurs sont publiés uniquement selon les règles de vérification du site (double proposition, modération).</p>
        </Section>

        <Section title="5. Données personnelles">
          <p>Aucune position GPS n'est stockée : elle reste sur l'appareil de l'utilisateur. Les adresses IP ne sont jamais conservées en clair ; seule une empreinte chiffrée et temporaire est conservée pour la lutte contre les abus, puis supprimée.</p>
          <p>Pour exercer vos droits (RGPD) : <a href="mailto:antoine@ah2020.fr" className="text-sky-400 hover:underline">antoine@ah2020.fr</a>.</p>
        </Section>

        <Section title="6. Signalement d'un contenu illicite">
          <p>Tout contenu illicite peut être signalé à <a href="mailto:antoine@ah2020.fr" className="text-sky-400 hover:underline">antoine@ah2020.fr</a>. Un retrait rapide sera effectué après examen.</p>
        </Section>

        <Section title="7. Propriété intellectuelle et droit applicable">
          <p>Les marques, logos et éléments du site sont protégés. Les informations agrégées restent la propriété de leurs sources respectives, citées et liées. Toute reproduction non autorisée est interdite.</p>
          <p>Le présent site est édité par une société de droit américain (Wyoming) et destiné au public français ; les dispositions impératives de la loi française, notamment la LCEN et le RGPD, s'appliquent aux utilisateurs situés en France.</p>
        </Section>

        <nav className="pt-5 border-t border-slate-800 flex flex-wrap gap-x-4 gap-y-1 text-xs">
          <Link to="/cgu" className="text-sky-400 hover:underline">Conditions d'utilisation</Link>
          <Link to="/confidentialite" className="text-sky-400 hover:underline">Politique de confidentialité</Link>
          <Link to="/cookies" className="text-sky-400 hover:underline">Politique de cookies</Link>
        </nav>
      </div>

      <Footer />
    </div>
  );
}
